export const reviews = [
  {
    id: 1,
    productId: 1, // iPhone 15 Pro
    rating: 5,
    title: "¡Increíble teléfono!",
    comment: "La cámara es espectacular y el rendimiento es inigualable. Vale cada centavo.",
    author: "Juan Pérez",
    date: "2023-10-26"
  },
  {
    id: 2,
    productId: 1,
    rating: 4,
    title: "Muy buen equipo, pero caro",
    comment: "Funciona de maravilla, pero el precio es un poco elevado. La batería dura todo el día.",
    author: "María García",
    date: "2023-10-20"
  },
  {
    id: 3,
    productId: 2, // Samsung Galaxy S23 Ultra
    rating: 5,
    title: "El mejor Android que he tenido",
    comment: "El S-Pen es súper útil y la pantalla es impresionante. Muy contento con la compra.",
    author: "Carlos Ruiz",
    date: "2023-10-25"
  },
  {
    id: 4,
    productId: 3, // Apple Watch Series 9
    rating: 4,
    title: "Excelente para el ejercicio",
    comment: "Mide todo con precisión y es muy cómodo. La batería podría durar un poco más.",
    author: "Ana López",
    date: "2023-10-22"
  },
  {
    id: 5,
    productId: 5, // Xiaomi 13 Pro
    rating: 4,
    title: "Gran relación calidad-precio",
    comment: "Rápido, buena cámara y diseño premium. Xiaomi sigue sorprendiendo.",
    author: "Pedro Gómez",
    date: "2023-10-18"
  },
  {
    id: 6,
    productId: 7, // POCO F5 Pro
    rating: 5,
    title: "Perfecto para gaming",
    comment: "Corre todos los juegos sin problemas, no se calienta y la pantalla es fluida. ¡Recomendado!",
    author: "Sofía Hernández",
    date: "2023-10-27"
  }
];